import { Component, OnInit, Input } from '@angular/core';
import * as myGlobals from '../../global';
import { Router, NavigationExtras } from '@angular/router';
import * as myLanguages from '../../common/vars_translate';

@Component({
  selector: 'app-tnnewslist-item',
  template: '<p>asd</p>',
  templateUrl: '../../themes/default/html/tnnewslist-item.component.html',
  styleUrls: ['../../themes/default/css/tnnewslist-item.component.scss']
})
export class TnnewslistItemComponent implements OnInit {

  @Input()
  newsData: any;
  imageData: any;
  showimage: boolean = false;
  News: any;

  constructor(private router: Router) {
    this.News = Object.assign([],myLanguages.translations_IT.News);
   }

  ngOnInit() {
    
    this.newsData.Date = this.newsData.Date * 1000;

    try {
      this.imageData = JSON.parse(this.newsData.Images)[0].url;
    } catch (e) {
      this.imageData = '';
    }

    if (this.imageData == '' || this.imageData == undefined ) { 
      this.showimage = false; 
    } else { 
      this.imageData = myGlobals.apiBasePath + this.imageData 
      this.showimage = true;
    }
  }

  // On_SingleNewsClick(id) {
  //   this.router.navigate(['/newsdetail']);
  // }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnnewslist-item/tnnewslist-item.component.ts